import React, { useContext } from 'react';
import { Input, PlusOutlined, Tooltip } from '@fx-ui/fine-design';
import { Intl } from '../../../constants';
import { filter, get, has, includes, isArray, isString, map } from '@libs/shared';
import { getPluginDefaultNameById } from '../../../utils';
import PluginRichText from '../plugin-rich-text';
import { PLUGIN_ARGUMENT_FIELD_TYPE, PLUGIN_ARGUMENT_VALUE_FROM } from '../../../interfaces';
import { PluginComponentContext } from '../plugin-component';
import FieldVariableSelect from '../field-variable-select';

/**
 * 插件-文本字段
 */
const PluginText = () => {
    const pluginComponentStore = useContext(PluginComponentContext);

    if (!pluginComponentStore) {
        return null;
    }

    const {
        field,
        fieldValue,
        optionalFields,
        isView,
        checkStatusVisible,
        resolverCtx,
        onParameterExprSelectorRender,
        onChange
    } = pluginComponentStore;

    const exprResolverKey = `${resolverCtx}${PLUGIN_ARGUMENT_VALUE_FROM.EXPR}`;

    // 当前参数类型可选择的表单字段
    const availableFields = filter(optionalFields, (v) => {
        return (
            includes(v.fields, PLUGIN_ARGUMENT_FIELD_TYPE.TEXT) && has(v.resolvers, exprResolverKey)
        );
    });

    const renderContext = () => {
        const { isRequired, fieldConf, isEnabled } = field;
        const value = fieldValue.resolver_arg;
        const isError = checkStatusVisible && isRequired && !value;
        const selectType = get(fieldValue, 'resolver_type', PLUGIN_ARGUMENT_VALUE_FROM.LITERAL);

        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.LITERAL) {
            const isMultiLine = get(fieldConf, 'isMultiLine', false);
            if (isMultiLine) {
                return (
                    <Input.TextArea
                        disabled={!isEnabled}
                        readonly={isView}
                        inputState={isError ? 'error' : undefined}
                        value={isString(value) ? value : undefined}
                        onChange={(v) => {
                            onChange(v);
                        }}
                    />
                );
            } else {
                return (
                    <Input
                        disabled={!isEnabled}
                        readonly={isView}
                        inputState={isError ? 'error' : undefined}
                        value={isString(value) ? value : undefined}
                        onChange={(v) => {
                            onChange(v);
                        }}
                    />
                );
            }
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.EXPR) {
            const config = {
                disabled: !isEnabled,
                value: isString(value) ? value : '',
                isMultiLine: get(fieldConf, 'isMultiLine', false),
                onChange: onChange
            };

            if (onParameterExprSelectorRender) {
                return onParameterExprSelectorRender(config);
            }

            const richTextFields = map(availableFields, (v) => {
                const exprValue = get(v.resolvers, exprResolverKey);
                return {
                    id: v.id,
                    value: exprValue?.arg?.replace(/ /g, ''),
                    fieldType: exprValue?.label?.trim(),
                    text: v.title || getPluginDefaultNameById(v.id),
                    // 特殊字段不展示后缀
                    hasAffix: !!v.title
                };
            });

            return (
                <PluginRichText
                    {...config}
                    fields={richTextFields}
                    renderAddBtn={() => (
                        <div className="field-select-btn">
                            <Tooltip
                                effect="light"
                                trigger="hover"
                                arrow={true}
                                placement="top"
                                content={Intl.get('field.member.insert')}
                            >
                                <PlusOutlined />
                            </Tooltip>
                        </div>
                    )}
                    mirrorOption={{
                        mode: 'label',
                        lineNumbers: false
                    }}
                />
            );
        }
        if (selectType === PLUGIN_ARGUMENT_VALUE_FROM.PROCESS_VAR) {
            return (
                <FieldVariableSelect
                    value={isArray(value) ? value : undefined}
                    argumentType={PLUGIN_ARGUMENT_FIELD_TYPE.TEXT}
                />
            );
        }
    };

    return <div className="fx-plugin-text">{renderContext()}</div>;
};

export default PluginText;
